import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { BaseSubmissionInformation } from './base-submission-information.component';
import { styleVariables } from '@lib/common';
import { Col, Skeleton, Space } from 'antd';
import styled from 'styled-components';
import { Responsive } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SectionGradeRow = styled.div.withConfig({
  displayName: "practice-submission-informationcomponent__SectionGradeRow",
  componentId: "sc-16dgosp-0"
})(["width:100%;display:flex;flex-wrap:wrap;margin:0 auto 16px auto;"]);
var SectionGradeItem = styled.div.withConfig({
  displayName: "practice-submission-informationcomponent__SectionGradeItem",
  componentId: "sc-16dgosp-1"
})([""]);
var SectionGradeSummary = styled(Space).withConfig({
  displayName: "practice-submission-informationcomponent__SectionGradeSummary",
  componentId: "sc-16dgosp-2"
})(["width:100%;margin-block:8px;padding-inline:16px;"]);
var SubmissionResultCard = styled.div.withConfig({
  displayName: "practice-submission-informationcomponent__SubmissionResultCard",
  componentId: "sc-16dgosp-3"
})(["margin-top:8px;display:flex;flex-direction:row;align-items:center;justify-content:center;height:36px;padding:16px;border-radius:8px;gap:8px;background-color:", ";", ""], function (props) {
  if (props.isPassed) {
    return styleVariables.colors.green2;
  }

  return styleVariables.colors.red5;
}, function (props) {
  return props.theme.media.desktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex-direction: column;\n    height: 100%;\n  "])));
});
var ExpectationResultLabel = styled.label.withConfig({
  displayName: "practice-submission-informationcomponent__ExpectationResultLabel",
  componentId: "sc-16dgosp-4"
})(["font-weight:600;font-size:14px;line-height:32px;color:", ";", ""], function (props) {
  if (props.isPassed) {
    return styleVariables.colors.green1;
  }

  return styleVariables.colors.red4;
}, function (props) {
  return props.theme.media.desktop(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 20px;\n  "])));
});
var NumberOfCorrectAnswerLabel = styled.label.withConfig({
  displayName: "practice-submission-informationcomponent__NumberOfCorrectAnswerLabel",
  componentId: "sc-16dgosp-5"
})(["font-weight:600;font-size:14px;line-height:24px;", ""], function (props) {
  return props.theme.media.desktop(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: 16px;\n  "])));
});
var AnnotationGroup = styled.div.withConfig({
  displayName: "practice-submission-informationcomponent__AnnotationGroup",
  componentId: "sc-16dgosp-6"
})(["display:flex;flex-direction:row;flex-wrap:wrap;user-select:none;"]);
var AnnotationItem = styled.div.withConfig({
  displayName: "practice-submission-informationcomponent__AnnotationItem",
  componentId: "sc-16dgosp-7"
})(["display:flex;align-items:center;margin:0 24px 16px 0;"]);
var Annotation = styled.div.withConfig({
  displayName: "practice-submission-informationcomponent__Annotation",
  componentId: "sc-16dgosp-8"
})(["width:16px;height:16px;border-radius:40px;margin-right:8px;background:", ";", ""], function (props) {
  return props.annotationColor;
}, function (props) {
  return props.theme.media.desktop(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: 24px;\n    height: 24px;\n  "])));
});
var AnnotationLabel = styled.label.withConfig({
  displayName: "practice-submission-informationcomponent__AnnotationLabel",
  componentId: "sc-16dgosp-9"
})(["color:", ";font-size:14px;font-weight:400;", ""], styleVariables.colors.gray11, function (props) {
  return props.theme.media.desktop(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    font-size: 16px;\n  "])));
});
export var PracticeSubmissionInformation = function PracticeSubmissionInformation(props) {
  var isLoadingGetFormReleaseById = props.isLoadingGetFormReleaseById,
      isLoadingGetSubmissionById = props.isLoadingGetSubmissionById,
      isPassed = props.isPassed,
      scorePerSection = props.scorePerSection,
      formRelease = props.formRelease,
      assignment = props.assignment,
      isLoadingGetAssignmentById = props.isLoadingGetAssignmentById,
      submission = props.submission,
      label = props.label,
      questionReleases = props.questionReleases;

  var renderScoreLabel = function renderScoreLabel(totalScore) {
    if (!scorePerSection.length) {
      return /*#__PURE__*/_jsx(Skeleton.Input, {
        size: "small",
        active: true
      });
    }

    var earnedScore = scorePerSection.reduce(function (sum, score) {
      return sum + score;
    }, 0);
    return /*#__PURE__*/_jsxs(NumberOfCorrectAnswerLabel, {
      children: [earnedScore, "/", totalScore, " ", label.score]
    });
  };

  var renderSubmissionResultInformation = function renderSubmissionResultInformation() {
    var _submission$result, _submission$result2;

    var isLoadingResources = isLoadingGetSubmissionById || isLoadingGetAssignmentById || isLoadingGetFormReleaseById;

    if (isLoadingResources) {
      return /*#__PURE__*/_jsx(Skeleton, {
        active: true
      });
    }

    return /*#__PURE__*/_jsx(Col, {
      xs: 24,
      xl: 10,
      children: /*#__PURE__*/_jsxs(SubmissionResultCard, {
        isPassed: isPassed,
        children: [/*#__PURE__*/_jsxs(ExpectationResultLabel, {
          isPassed: isPassed,
          children: [(_submission$result = submission.result) === null || _submission$result === void 0 ? void 0 : _submission$result.expectationResult, "% - ", (_submission$result2 = submission.result) === null || _submission$result2 === void 0 ? void 0 : _submission$result2.status.name]
        }), renderScoreLabel(formRelease.sections.reduce(function (sum, section) {
          var _section$totalScore;

          return sum + ((_section$totalScore = section.totalScore) !== null && _section$totalScore !== void 0 ? _section$totalScore : 0);
        }, 0))]
      })
    });
  };

  var renderSectionSummaries = function renderSectionSummaries() {
    if (isLoadingGetFormReleaseById || !scorePerSection.length) {
      return /*#__PURE__*/_jsx(Skeleton, {
        active: true
      });
    }

    return /*#__PURE__*/_jsx(Responsive.DesktopScreen, {
      children: /*#__PURE__*/_jsx(SectionGradeRow, {
        children: formRelease.sections.map(function (section, index) {
          return /*#__PURE__*/_jsx(SectionGradeItem, {
            children: /*#__PURE__*/_jsxs(SectionGradeSummary, {
              direction: "vertical",
              children: [/*#__PURE__*/_jsxs("span", {
                children: [label.section, " ", index + 1]
              }), /*#__PURE__*/_jsxs(NumberOfCorrectAnswerLabel, {
                children: [scorePerSection[index], "/", section.totalScore, " ", label.score]
              })]
            })
          }, index);
        })
      })
    });
  };

  return /*#__PURE__*/_jsx(BaseSubmissionInformation, _objectSpread(_objectSpread({}, props), {}, {
    resultColumn: renderSubmissionResultInformation(),
    children: renderSectionSummaries()
  }));
};